import * as qs from 'app/lib/helperjs';
import {RegisterType} from 'app/components/sign/registration/registerType';

export const HOOK_SELECTOR = '#hook-register-modal';

export const registerModalPropsResolver = (state) => {
    const element = qs.querySelector(HOOK_SELECTOR);

    if (!element) {
        return;
    }

    const calculatorInProgress = state.calculator.inProgress;
    const isBusiness = qs.getData(element, 'isBusiness');

    return {
        calculatorInProgress,
        registerTab: isBusiness ? RegisterType.BUSINESS : RegisterType.INDIVIDUAL,
    }
};